import { useState } from "react";
import { Search, Star, Locate } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const FILTERS = ["All", "Attractions", "Restaurants", "Hotels", "Transit"];
const PLACES = [
  { id: "senso", name: "Senso-ji Temple", type: "Cultural Landmark", rating: 4.7, reviews: 3215,
    img: "https://images.unsplash.com/photo-1583400013091-ea9f8ba8d3f4?auto=format&fit=crop&w=500&q=70" },
  { id: "skytree", name: "Tokyo Skytree", type: "Observation Deck", rating: 4.6, reviews: 4820,
    img: "https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?auto=format&fit=crop&w=500&q=70" },
];

export default function MspMaps() {
  const [f, setF] = useState("Attractions");
  return (
    <MspShell title="Maps" testid="msp-maps">
      <div className="bg-white rounded-2xl border border-slate-200 flex items-center gap-2 px-4 py-3 shadow-sm">
        <Search className="w-4 h-4 text-slate-400" />
        <input data-testid="msp-maps-search" defaultValue=""
          placeholder="Search places, attractions, restaurants..."
          className="flex-1 bg-transparent outline-none text-slate-800 placeholder:text-slate-400" />
      </div>
      <div className="flex gap-2 overflow-x-auto scrollbar-none" style={{ scrollbarWidth: "none" }}>
        {FILTERS.map((x) => (
          <button key={x} onClick={() => setF(x)} data-testid={`msp-maps-filter-${x.toLowerCase()}`}
            className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-700 border ${f === x ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-200"}`}>
            {x}
          </button>
        ))}
      </div>

      {/* Faux map */}
      <div className="relative rounded-3xl overflow-hidden border border-slate-200 h-64 bg-slate-100" data-testid="msp-maps-canvas">
        <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&w=1200&q=70"
          alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/25" />
        <div className="absolute top-4 left-4 text-blue-900 font-serif font-800 text-2xl leading-none">
          Tokyo <span className="block text-base text-slate-700 mt-1">東京</span>
        </div>
        <button aria-label="My location" className="absolute bottom-4 right-4 w-11 h-11 rounded-full bg-white shadow grid place-items-center text-blue-600 hover:brightness-110">
          <Locate className="w-5 h-5" />
        </button>
        <span className="absolute top-1/3 left-1/3 w-4 h-4 rounded-full bg-emerald-500 ring-4 ring-emerald-200" />
        <span className="absolute top-1/2 left-2/3 w-4 h-4 rounded-full bg-rose-500 ring-4 ring-rose-200" />
        <span className="absolute top-2/3 left-1/2 w-4 h-4 rounded-full bg-blue-500 ring-4 ring-blue-200" />
      </div>

      <div className="space-y-3">
        {PLACES.map((p) => (
          <div key={p.id} data-testid={`msp-place-${p.id}`}
            className="flex items-stretch bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm">
            <div className="w-24 shrink-0 relative">
              <img src={p.img} alt="" className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="flex-1 p-4">
              <div className="font-serif font-700 text-base text-slate-900">{p.name}</div>
              <div className="text-xs text-slate-500 mt-1">{p.type}</div>
              <div className="flex items-center gap-1 text-xs text-amber-600 mt-2">
                <Star className="w-3.5 h-3.5 fill-amber-500 stroke-none" /> <span className="font-700">{p.rating}</span>
                <span className="text-slate-400">({p.reviews})</span>
              </div>
              <button className="mt-2 text-xs font-700 text-blue-700 hover:underline" data-testid={`msp-place-${p.id}-directions`}>Get Directions →</button>
            </div>
          </div>
        ))}
      </div>
    </MspShell>
  );
}
